import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import collectPreviewTargets from './utils/collectLinks';
import { mountCard, removeCardsWithin, sweepDetachedCards, unmountCardsWithin } from './utils/cardRegistry';

/**
 * `extend()` passes the extended method's return value first and its arguments after,
 * so the vnode arrives second, and a module named by path gives it nothing to infer.
 */
const onPostRender = function (_) {
  sweepDetachedCards();
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  const vnode = args[0];
  const body = vnode.dom.querySelector('.Post-body');
  if (!body) return;
  if (previewsHidden()) {
    removeCardsWithin(body);
    return;
  }
  if (isBeingEdited(this, body)) return;
  if (isConcealed(vnode.dom)) return;
  collectPreviewTargets(body).forEach(mountCard);
};
const onPostRemove = function (_) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  const vnode = args[0];
  unmountCardsWithin(vnode.dom);
};

/** `CommentPost` is code split in Flarum 2: importing it would bundle a second copy and patch the one the page never loads. */
export default function addLinkPreviews() {
  extend('flarum/forum/components/CommentPost', ['oncreate', 'onupdate'], onPostRender);
  extend('flarum/forum/components/CommentPost', 'onremove', onPostRemove);
}
function previewsHidden() {
  return Boolean(app.session.user?.preferences()?.hideLinkPreviews);
}

/**
 * `ComposerPostPreview` rewrites its own subtree from the raw text every 50ms, by a
 * diff that knows nothing about anything mounted into it, so a card put there is
 * torn out from under Mithril within the next tick.
 */
function isBeingEdited(post, body) {
  if (body.querySelector('.Post-preview') !== null) return true;
  const isEditing = post.isEditing;
  return typeof isEditing === 'function' && isEditing.call(post) === true;
}

/**
 * A deleted post the reader has not opened: core renders the content anyway and only
 * collapses it with CSS, so every link there would spend a request behind `display: none`.
 */
function isConcealed(post) {
  return post.classList.contains('Post--hidden') && !post.classList.contains('revealContent');
}